import { EntityVariation } from "../../entity/EntityVariation";

export class DtoVariationsPutRes extends EntityVariation {}
